import axios from 'axios';
import {
  AMOUNT_PER_UNIT,
  NEW_ARTICLES,
    } from 'src/utils/constants';
import {  diffInDates , getArticleIndividualAmount , getArticleNumber , getOtherArticlesUnit , isArticleTaxFree} from '../../../../utils/commonFunc'
import {getSeparatedUserCalculationsTotal} from './InvoiceCalculationsUtil';
export const fetchInvoiceCalculations = async ({
  watch,
  setSpinner,
  otherArticlesData,
  currencyGlobalValue,
  vat,
  pension,
  pensionAmount,
  rutDeduction,
  rootDeduction,
  expressPayout,
  holidaySavings,
  holidaySavingFee,
  globalData,
  currency,
  userID,
  customer,
  selectedCustomer,
  setSeperatedUserCalculations,
  setCalculatedAmounts,
  anyArrayHasValue,
  HourlyWages,
  allowancePerDaySweden,
   prefillingData,
   setGrossSalary,
}) => {
  const invoiceHours = watch("invoiceHours");

  try {
    if (!invoiceHours && !anyArrayHasValue) {
      setCalculatedAmounts(0);
      return;
    }

    setSpinner(true);

    const calculations = await Promise.all(
      (invoiceHours || []).map(async (userInvoiceHours, userIndex) => {
        const userOtherArticles = otherArticlesData[userIndex] || [];
        const totalAmount = Object.values(userInvoiceHours).reduce(
          (total, entry) => total + entry.units * entry.amount,
          0
        );

        const userArticleHourlyAmount = Object.values(userInvoiceHours).reduce(
          (total, entry) =>
            entry.article.articleNumber === "92"
              ? total + entry.units * entry.amount
              : total,
          0
        );

        const mileageAmount = getArticleIndividualAmount(NEW_ARTICLES.MILEAGE, "isMileageArticleShowInInvoice", userOtherArticles);
        const allowanceOsAmount = getArticleIndividualAmount(NEW_ARTICLES.ALLOWANCE_OUT, "isArticleShowInInvoiceOS", userOtherArticles);
        const allowanceIsAmount = getArticleIndividualAmount(NEW_ARTICLES.ALLOWANCE_IN, "isArticleShowInInvoiceIS", userOtherArticles);
        const travelAmount = getArticleIndividualAmount(NEW_ARTICLES.TRAVEL, "isTravelArticleShowInInvoice", userOtherArticles);
        const expAmount = getArticleIndividualAmount(NEW_ARTICLES.MATERIAL_VAT, "isMaterialArticleShowInInvoice", userOtherArticles);

        const filteredInvoiceHours = invoiceHours.filter((item) => item !== undefined || item !== null);

        const totalWorkingDates = [];
        [userInvoiceHours]?.forEach((items) => {
          Object.keys(items)?.forEach((date) => {
            const [year, month, day] = date?.split("-");
            totalWorkingDates.push({
              id: 0,
              workingDate: `${year}-${month}-${day}`,
              dateId: date,
              number: items[date].units,
              unit: items[date].article.unit,
              vat,
              isArticleShownInInvoice: true,
              amountPerUnit: items[date].amount,
              amount: items[date].amount * items[date].units,
              articleNumber: items[date].article?.articleNumber,
              workingDescription: items[date].workingDescription || "",
              houseworkType: items[date].houseworkType?.value || "",
              workingHour: items[date].article?.articleNumber === HourlyWages ? items[date].units : 0,
              isUnitArticle: items[date].article?.isUnitArticle || false,
            });
          });
        });

        if (anyArrayHasValue) {
          Object.entries([userOtherArticles])?.forEach(([_, value]) => {
            value?.forEach((item) => {
              const requiredFlags = [
                "isMileageArticleShowInInvoice",
                "isArticleShowInInvoiceOS",
                "isArticleShowInInvoiceIS",
                "isTravelArticleShowInInvoice",
                "isMaterialArticleShowInInvoice",
              ];
              const isMileage = item.key === NEW_ARTICLES.MILEAGE;
              const isAllowance = item.key === NEW_ARTICLES.ALLOWANCE_OUT || item.key === NEW_ARTICLES.ALLOWANCE_IN;

              const currencyFactor = isNaN(parseFloat(currencyGlobalValue)) ? 1 : Number(currencyGlobalValue);

              const amountPerUnitSek = isMileage
                ? AMOUNT_PER_UNIT.MILEAGE
                : isAllowance
                ? item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key]
                : Number(item?.value);

              const amountPerUnit = isMileage
                ? AMOUNT_PER_UNIT.MILEAGE / currencyFactor
                : isAllowance
                ? (isNaN(parseFloat(item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key])) ? 0 : Number(item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key])) / currencyFactor
                : (isNaN(parseFloat(item?.value)) ? 0 : Number(item?.value)) / currencyFactor;

              const number = isMileage
                ? item?.data?.distance
                : isAllowance
                ? diffInDates(item?.key, item?.data?.tripEndedDateIs || item?.data?.tripEndedDate, item?.data?.tripStartedDateIs || item?.data?.tripStartedDate, item?.data?.tripEndedDateOs || item?.data?.tripEndedDate, item?.data?.tripStartedDateOs || item?.data?.tripStartedDate)
                : "1";

              totalWorkingDates.push({
                id: 0,
                number,
                unit: getOtherArticlesUnit(item, 'unit'),
                amountPerUnitSek,
                amountPerUnit,
                articleNumber: getArticleNumber(item),
                workingDescription: item?.label,
                houseworkType: '',
                workingHour: 0,
                isTaxFreeArticle: isArticleTaxFree(item),
                isArticleShownInInvoice:
                requiredFlags.every((flag) => item.data?.[flag] === "1") || item?.data?.isArticleShownInInvoice,
                isPdfAttachedToInvoice: true,
                tripStartedPlace: item?.data?.tripStartedPlace,
                distance: item?.data?.distance || 0,
                country: item?.key === NEW_ARTICLES.ALLOWANCE_OUT ? item?.data?.country : item?.key === NEW_ARTICLES.ALLOWANCE_IN ? 'Sweden' : '',
                reasonForTrip: item?.data?.reasonForTrip || '',
                carRegistrationNo: item?.data?.carRegistrationNo || '',
                vat: item?.data?.vat != null ? Number(item?.data?.vat) : vat,
                tripStartedDate: item?.data?.tripStartedDate?.split('T')[0] || '',
                tripEndedDate: item?.data?.tripEndedDate?.split('T')[0] || '',
                amount: isNaN(parseFloat(item?.valueInSelectedCurrency)) ? 0.0 : Number(item?.valueInSelectedCurrency),
                totalDayOfTravels: diffInDates(item?.key, item?.data?.tripEndedDateIs || item?.data?.tripEndedDate, item?.data?.tripStartedDateIs || item?.data?.tripStartedDate, item?.data?.tripEndedDateOs || item?.data?.tripEndedDate, item?.data?.tripStartedDateOs || item?.data?.tripStartedDate),
                allowanceDestination: item?.data?.destination || item?.data?.allowanceDestination || '',
                expenseCategory: '',
                fileName: '',
                fileContent: '',
                foodAllowance: item?.data?.totalFoodRate || 0,
                amountInSek: Number(item?.value),
                isHalfDay: item?.data?.isHalfDay,
              });
            });
          });
        }

         const pensionValue = pension && typeof pension === 'object' ? pension[userIndex] : pension;
        const pensionAmountValue = pensionAmount && typeof pensionAmount === 'object' ? pensionAmount[userIndex] : pensionAmount;
        
        const currentPension = (pensionValue !== undefined && pensionValue !== null && pensionValue !== '' && pensionValue > 0) 
          ? pensionValue 
          : prefillingData?.getInvoiceData?.freelancer?.[userIndex]?.pension;

        const currentPensionAmount = (pensionAmountValue !== undefined && pensionAmountValue !== null && pensionAmountValue !== '' && pensionAmountValue > 0) 
          ? pensionAmountValue 
          : prefillingData?.getInvoiceData?.freelancer?.[userIndex]?.pensionAmount;


        const payload = {
          vat,
          travel: 0,
          allowance: 0,
          pension: currentPension,
          amount: parseFloat(totalAmount + mileageAmount + allowanceOsAmount + allowanceIsAmount + travelAmount + expAmount),
          rutDeduction,
          rootDeduction,
          expressPayout,
         holidaySavings: holidaySavings && typeof holidaySavings === 'object' ? holidaySavings[userIndex] : holidaySavings,
          pensionFee: 0,
         pensionAmount: currentPensionAmount || 0,
          tax: parseFloat(globalData.tax.globalValue),
          fee: parseFloat(globalData.fee.globalValue),
          expenditureForMaterialsAndToolsTaxFreeAmount: 0,
          HourlyWagesAmount: userArticleHourlyAmount || 0,
          rutTaxValue: parseFloat(globalData.rutTax.globalValue),
          socialFee: parseFloat(globalData.socialFee.globalValue),
          rootTaxValue: parseFloat(globalData.rootTax.globalValue),
          expressFee: expressPayout ? Number(globalData.expressFee.globalValue) : 0,
         holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === 'object' ? holidaySavingFee[userIndex] : (holidaySavings ? holidaySavingFee : 0),
          currencyRate: globalData.currencies.find((item) => item.description === currency)?.globalValue,
          currencyName: currency,
          userId: Number(userID),
          invoiceType: customer?.customerAddress?.[0]?.invoiceType || customer?.invoiceType,
          invoiceNumber : prefillingData?.getInvoiceData?.invoiceNumber || 0,
          numberOfFreelancers: filteredInvoiceHours?.length,
          workingHours: totalWorkingDates,
          customerId: selectedCustomer?.customerId,
          createdDate: new URLSearchParams(window.location.search).get('createdDate') || new Date()
        };

        const res = await axios.post("/admin/invoice/invoicecalculations", payload);
        return res?.data.response;
      })
    );

    setSeperatedUserCalculations(calculations);
    const totalCalculation = getSeparatedUserCalculationsTotal(calculations);
    setCalculatedAmounts(totalCalculation);
    setGrossSalary(totalCalculation.grossInSek);
  } catch (err) {
    console.error(err);
    setCalculatedAmounts(0);
  } finally {
    setSpinner(false);
  }
};
